
/* global H5PStandalone */
import React from 'react';

const Gml2 = () => {
  return (
    <iframe
      src="/gml-2/index.html"
      title="H5P GameMap"
      width="100%"
      height="1000px"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default Gml2;